<template>
    <div>
      <TaxWarrantsComp />
    </div>
  </template>

<script>
import TaxWarrantsComp from '../../../../components/tax/warrants/TaxWarrants.vue';

export default {
  name: 'TaxWarrants',
  components: {
    TaxWarrantsComp,
  },
};
</script>
